var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"QuestionDifficulty"},[_c('p',{staticClass:"secondary mb-8"},[_vm._v(" Difficulty ")]),_c('div',{staticClass:"flex"},_vm._l((_vm.difficulties),function(difficulty){return _c('div',{key:difficulty.id,staticClass:"w-10 h-10 ml-4 rounded-DEFAULT bg-brand_dark-primary",class:{
        'bg-brand_dark-primary': difficulty.isActive,
        'bg-gray_light-secondary': !difficulty.isActive,
      }})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }